import { render, staticRenderFns } from "./select-field.vue?vue&type=template&id=cf6920c8&scoped=true"
import script from "./select-field.vue?vue&type=script&lang=js"
export * from "./select-field.vue?vue&type=script&lang=js"
import style0 from "./select-field.vue?vue&type=style&index=0&id=cf6920c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6920c8",
  null
  
)

export default component.exports